/**
 * Anketa – tipy na písně od návštěvníků veřejného webu.
 * Tipy posílají návštěvníci přes anketu na amatiband.ozvuceniplzen.cz
 * (tabulka web_song_requests). Muzikanti zde můžou o tipech hlasovat
 * (👍 chci hrát) a mazat je.
 */
import { supabase } from '../lib/supabase.js';

function esc(s) {
    if (s == null) return '';
    return String(s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function fmtDate(d) {
    const dt = new Date(d);
    return `${dt.getDate()}. ${dt.getMonth() + 1}. ${dt.getFullYear()}`;
}

function voterWord(n) {
    return n === 1 ? 'hlas' : (n < 5 ? 'hlasy' : 'hlasů');
}

export async function renderAnketa(container) {
    container.innerHTML = '<div class="state-banner">Načítám…</div>';

    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
        container.innerHTML = '<div class="state-banner">Nejdřív se přihlas.</div>';
        return;
    }

    const [reqRes, votesRes, profilesRes] = await Promise.all([
        supabase.from('web_song_requests').select('*').order('created_at', { ascending: false }),
        supabase.from('web_song_request_votes').select('*'),
        supabase.from('profiles').select('id, name')
    ]);

    if (reqRes.error) {
        container.innerHTML = `<div class="state-banner error">Chyba: ${esc(reqRes.error.message)}</div>`;
        return;
    }

    const requests = reqRes.data || [];
    const votes = votesRes.data || [];
    const profilesMap = new Map((profilesRes.data || []).map((p) => [p.id, p.name]));

    const votesByReq = new Map();
    votes.forEach((v) => {
        if (!votesByReq.has(v.request_id)) votesByReq.set(v.request_id, []);
        votesByReq.get(v.request_id).push(v);
    });

    const enriched = requests.map((r) => {
        const all = votesByReq.get(r.id) || [];
        return {
            ...r,
            myVote: all.some((v) => v.user_id === user.id),
            voteCount: all.length,
            voters: all.map((v) => profilesMap.get(v.user_id) || '?')
                .sort((a, b) => a.localeCompare(b, 'cs'))
        };
    });

    // Nejvíc hlasů nahoře, pak nejnovější.
    enriched.sort((a, b) => (b.voteCount - a.voteCount)
        || (new Date(b.created_at) - new Date(a.created_at)));

    container.innerHTML = `
        <div class="filters">
            <h2 style="font-size:18px; margin-right:auto;">Anketa – tipy z webu</h2>
            <span style="font-size:13px;color:var(--text-muted);">
                ${requests.length} ${requests.length === 1 ? 'tip' : (requests.length < 5 ? 'tipy' : 'tipů')}
            </span>
        </div>

        <div class="tips-list">
            ${enriched.length === 0
                ? '<div class="state-banner">Zatím žádné tipy. Návštěvníci je posílají přes anketu na veřejném webu.</div>'
                : enriched.map((r) => renderRow(r)).join('')}
        </div>

        <div class="footer-note">
            Tipy na písně posílají návštěvníci přes anketu na veřejném webu.
            Kliknutím na <strong>👍 Chci hrát</strong> dáš najevo, že píseň chceš zařadit —
            najetím na počet hlasů uvidíš, kdo hlasoval. Tlačítkem <strong>🗑</strong> tip smažeš.
        </div>
    `;

    container.querySelectorAll('[data-vote]').forEach((btn) => {
        btn.addEventListener('click', async () => {
            const id = btn.dataset.vote;
            const mine = btn.dataset.mine === '1';
            let error;
            if (mine) {
                ({ error } = await supabase.from('web_song_request_votes')
                    .delete().eq('request_id', id).eq('user_id', user.id));
            } else {
                ({ error } = await supabase.from('web_song_request_votes')
                    .insert({ request_id: id, user_id: user.id }));
            }
            if (error) { alert('Hlasování selhalo: ' + error.message); return; }
            renderAnketa(container);
        });
    });

    container.querySelectorAll('[data-del]').forEach((btn) => {
        btn.addEventListener('click', async () => {
            const r = enriched.find((x) => x.id === btn.dataset.del);
            if (!r) return;
            if (!confirm(`Smazat tip „${r.song}"? Tato akce je nevratná.`)) return;
            const { error } = await supabase.from('web_song_requests').delete().eq('id', r.id);
            if (error) { alert('Smazání selhalo: ' + error.message); return; }
            renderAnketa(container);
        });
    });
}

function renderRow(r) {
    const voterTip = r.voters.length ? r.voters.join(', ') : 'Zatím nikdo nehlasoval';
    return `
        <div class="tip-row">
            <div class="tip-title">${esc(r.song)}</div>
            <div class="tip-voteline">
                <button class="btn btn-sm${r.myVote ? ' btn-primary' : ''}"
                        data-vote="${r.id}" data-mine="${r.myVote ? 1 : 0}">👍 Chci hrát</button>
                <div class="tip-totals" title="${esc(voterTip)}">
                    <span class="tip-voter-count">${r.voteCount} ${voterWord(r.voteCount)}</span>
                </div>
                <button class="btn btn-sm rep-btn-danger" data-del="${r.id}"
                        style="margin-left:auto;" title="Smazat tip">🗑</button>
            </div>
            <div class="tip-by">${fmtDate(r.created_at)}</div>
        </div>
    `;
}
